import LazyLoad from "vanilla-lazyload"

export default new LazyLoad({
  // eslint-disable-next-line camelcase
  elements_selector: ".lazy"
})
